import { Paper, Stack } from "@mui/material";

import type { UseTransientScenariosReturn } from "../hooks/useTransientScenarios";
import type { ScenarioDefinitionFormState } from "../model/transientScenario";

import { ScenarioDefinitionFields } from "./ScenarioDefinitionFields";

type ScenarioDefinitionRowProps = {
  scenario: ScenarioDefinitionFormState;
  scenariosState: UseTransientScenariosReturn;
};

export const ScenarioDefinitionRow = ({ scenario, scenariosState }: ScenarioDefinitionRowProps) => {
  return (
    <Paper className="p-3 px-5 shadow-md">
      <Stack className=" w-full flex-col items-start gap-ds-1-25x">
        <Stack className="gap-ds-0-75x">
          <span className="h-5 w-1 rounded-sm bg-lds-element-primary" />
          <span className="font-ds-headline-sm text-lds-foreground-primary">{scenario.name}</span>
        </Stack>
        <ScenarioDefinitionFields scenario={scenario} scenariosState={scenariosState} />
      </Stack>
    </Paper>
  );
};
